import type { IFilter } from '@dcentralexpedientedigital/fe-shared/types/config.interface';
import type { BlockLayoutProps } from '@dcentralexpedientedigital/fe-ui/components/block-layout/block-layout';

import type { LayoutComponentBlock } from './is-layout-component-block';

export interface LayoutBlock {
    blockLayout: 'grid' | 'column';
    columns: number;
    breakDirection?: 'forward' | 'reverse';
    targetAudience?: IFilter | null;
    components: LayoutComponentBlock[];
    spacing: BlockLayoutProps['spacing'];
}

export function isLayoutBlock(block: unknown): block is LayoutBlock {
    return !!block && typeof block === 'object' && 'blockLayout' in block && 'columns' in block;
}
